import { Injectable } from "@angular/core";
import { User } from "../../../models/index";

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

@Injectable()
export class MenuService {
  public menuItems = [
    {
      label: "Home",
      main: [
        {
          state: "home",
          short_label: "H",
          name: "Home",
          type: "link",
          icon: "ti-home",
          showAuthed: "yes",
          children: [],
        },
      ],
    },
    {
      label: "About this app",
      main: [
        {
          state: "info",
          short_label: "A",
          name: "About this app",
          type: "sub",
          icon: "ti-info-alt",
          children: [
            {
              state: "about",
              short_label: "A",
              name: "About",
              type: "link",
              icon: "ti-mobile",
            },
            {
              state: "privacy-policy",
              short_label: "Priv",
              name: "Privacy Policy",
              type: "link",
              icon: "ti-eye",
            },
            {
              state: "terms-of-use",
              short_label: "ToU",
              name: "Terms of Use",
              type: "link",
              icon: "ti-ticket",
            },
          ],
        },
      ],
    },
    {
      label: "Discover uMuzis",
      main: [
        {
          state: "communities",
          short_label: "uM",
          name: "Discover uMuzis",
          type: "link",
          icon: "ti-signal",
          children: [],
        },
      ],
    },
  ];

  public newUmuziItem = {
    label: "New uMuzi",
    main: [
      {
        state: "community-editor",
        short_label: "C",
        name: "New uMuzi",
        type: "link",
        icon: "ti-flag-alt-2",
        children: [],
      },
    ],
  };

  public newDiscussionItem = {
    label: "New Discussion",
    main: [
      {
        state: "discussion-editor",
        short_label: "D",
        name: "New Discussion",
        type: "link",
        icon: "ti-microphone",
        showAuthed: "no",
        children: [],
      },
    ],
  };

  constructor() {}

  ngOnInit() {}

  public addNewUmuziItem(user: User) {
    if (user.username) {
      this.menuItems.push(this.newUmuziItem);
    }
  }

  public addNewDiscussionItem(user: User) {
    if (user.username) {
      this.menuItems.push(this.newDiscussionItem);
    }
  }

  public getMenuItemsForAuth(user: User): Menu[] {
    this.addNewDiscussionItem(user);
    this.addNewUmuziItem(user);
    return this.menuItems;
  }

  public getDefaultMenuItems(): Menu[] {
    const defaultMenuLabels = ["Home", "Discover uMuzis", "About this app"];
    const defaultMenu = this.menuItems.filter((item) =>
      defaultMenuLabels.includes(item.label)
    );

    return defaultMenu;
  }
}
